import React from 'react';
import { cn } from '../../lib/utils';

const FundingPageHeader = ({
  eyebrow,
  title,
  subtitle,
  actions,
  className,
}) => (
  <div className={cn('mb-6 flex flex-wrap items-start justify-between gap-4', className)}>
    <div className="max-w-3xl">
      {eyebrow ? (
        <div className="mb-2 text-xs font-semibold uppercase tracking-[0.16em] text-[var(--fg-muted)]">
          {eyebrow}
        </div>
      ) : null}
      <h1 className="text-3xl font-bold tracking-tight text-[var(--fg-text)]">{title}</h1>
      {subtitle ? (
        <p className="mt-2 text-sm leading-6 text-[var(--fg-muted)]">{subtitle}</p>
      ) : null}
    </div>
    {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
  </div>
);

export default FundingPageHeader;
